import { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
    addStepIdToCompletedList,
    removeStepIdToCompletedList,
    selectBnEin,
    selectLinks,
    selectLetterhead,
    selectMissionStatement,
    selectCategories,
    selectPopulationsServed,
    selectGasServed,
    selectSdgServed,
} from "./slice";
import { steps } from ".";

export default function useStepCompleteSetter() {
    const dispatch = useDispatch();

    const bnein = useSelector(selectBnEin);
    const links = useSelector(selectLinks);
    const letterHead = useSelector(selectLetterhead);
    const missionStatement = useSelector(selectMissionStatement);
    const categories = useSelector(selectCategories);
    const populationsServed = useSelector(selectPopulationsServed);
    const gasServed = useSelector(selectGasServed);
    const sdgServed = useSelector(selectSdgServed);
    const {
        companyName,
        phoneNumber,
        addressLine,
        city,
        postalCode,
    } = useSelector((state) => state.organizationProfileState);

    const updateCompletedSteps = useCallback(() => {
        steps.forEach(({ id: stepId }) => {
            let isComplete = false;

            switch (stepId) {
                case "organizationInfo":
                    isComplete = !!(
                        companyName?.value?.trim() &&
                        phoneNumber?.value?.trim() &&
                        addressLine?.value?.trim() &&
                        city?.value?.trim() &&
                        postalCode?.value?.trim()
                    );
                    break;
                case "bnein":
                    isComplete = !!bnein?.trim();
                    break;
                case "links":
                    isComplete = Object.values(links || {}).some((link) =>
                        link?.trim()
                    );
                    break;
                case "headerFooter":
                    isComplete = !!(
                        letterHead?.header?.previewUrl ||
                        letterHead?.footer?.previewUrl
                    );
                    break;
                case "missionStatement":
                    isComplete = !!missionStatement?.trim();
                    break;
                case "categories":
                    isComplete = categories?.length > 0;
                    break;
                case "populationsServed":
                    isComplete = populationsServed?.length > 0;
                    break;
                case "gas":
                    isComplete = gasServed?.length > 0;
                    break;
                case "sdg":
                    isComplete = sdgServed?.length > 0;
                    break;
                default:
                    break;
            }

            if (isComplete) {
                dispatch(addStepIdToCompletedList(stepId));
            } else {
                dispatch(removeStepIdToCompletedList(stepId));
            }
        });
    }, [
        addressLine?.value,
        bnein,
        categories.length,
        city?.value,
        companyName?.value,
        dispatch,
        gasServed.length,
        letterHead.footer.previewUrl,
        letterHead.header.previewUrl,
        links,
        missionStatement,
        phoneNumber?.value,
        populationsServed.length,
        postalCode?.value,
        sdgServed.length,
    ]);

    return updateCompletedSteps;
}
